'use client';

import { use, useActionState } from 'react';
import { loginAction } from '@/lib/auth/auth.actions';

interface LoginFormProps {
  searchParams: Promise<{ registered?: string; error?: string }>;
  labels?: {
    passwordLabel?: string;
    submitLabel?: string;
    pendingLabel?: string;
    successMsg?: string;
    errorMsg?: string;
  };
}

export function LoginForm({ searchParams, labels }: LoginFormProps) {
  const params = use(searchParams);
  const [state, action, isPending] = useActionState(loginAction, undefined);

  const passwordLabel = labels?.passwordLabel ?? 'Password';
  const submitLabel   = labels?.submitLabel   ?? 'Sign In';
  const pendingLabel  = labels?.pendingLabel  ?? 'Signing in...';
  const successMsg    = labels?.successMsg    ?? '✓ Registration successful! Sign in below.';
  const errorMsg      = labels?.errorMsg      ?? 'Login error.';

  return (
    <form action={action} className="space-y-4">
      {params.registered && (
        <div className="badge-green w-full py-2 px-3 rounded-lg text-sm">
          {successMsg}
        </div>
      )}
      {(state?.error ?? params.error) && (
        <div className="badge-red w-full py-2 px-3 rounded-lg text-sm">
          {state?.error ?? errorMsg}
        </div>
      )}

      <div>
        <label htmlFor="email" className="label">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          className="input"
          placeholder="hello@example.com"
        />
      </div>

      <div>
        <label htmlFor="password" className="label">{passwordLabel}</label>
        <input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          className="input"
          placeholder="••••••••"
        />
      </div>

      <button type="submit" disabled={isPending} className="btn-primary w-full btn-lg">
        {isPending ? (
          <span className="flex items-center gap-2">
            <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
            </svg>
            {pendingLabel}
          </span>
        ) : submitLabel}
      </button>
    </form>
  );
}
